import React from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import { PublicFormResponse } from 'components/PublicFormResponse'
import routePath from 'router/routePath'

export const FtnCallbackError: React.FC = () => {
  const { t } = useTranslation(['registration'])
  const navigate = useNavigate()

  return (
    <PublicFormResponse
      title={t('registration:ftnCallbackErrorMessage')}
      description={t('registration:ftnCallbackErrorDescription')}
      status="error"
      onClick={() => {
        navigate(routePath.login)
      }}
      buttonText={t('registration:ftnCallbackErrorBackButtonText')}
    />
  )
}
